import { gql } from '@apollo/client';

export const FETCH_BULK_IMPORT_BREADCRUMB = gql`
  query fetchBulkImportTimestamp($bulkImportId: ObjectID!) {
    fetchBulkImport(bulkImportId: $bulkImportId) {
      bulkImport {
        createdAt
      }
    }
  }
`;
